import React, { useState } from 'react';
import styled from 'styled-components'
import { Button } from './controlblock';

export default function FourSet() {

  const [control, setControl] = useState(true);
  const [modes, setModes] = useState(false);
  const [tools, setTools] = useState(false);
  const [system, setSystem] = useState(false);

  return (<Grid>
    <CButton active={control} onClick={() => setControl(!control)}>Controls</CButton>
    <CButton active={modes} onClick={() => setModes(!modes)}>Modes</CButton>
    <CButton active={tools} onClick={() => setTools(!tools)}>Tools</CButton>
    <CButton active={system} onClick={() => setSystem(!system)}>System</CButton>
  </Grid>)
}

const Grid = styled.div`
  display: grid;
  grid-template-rows: 1fr 1fr;
  grid-template-columns: 1fr 1fr;
  grid-gap: 10px;
`;

const CButton = styled(Button)`
  background-color: ${({ active }) => active ? "#1f8efa" : "#1c63ad"};
  font-size: 14px;
  line-height: 16px;
`;